import { AppState } from 'app/store/reducers';
import get from 'lodash/get';

export const getRoms = (state: AppState) => get(state, 'roms', {});
export const getRomsRoms = (state: AppState) => get(getRoms(state), 'roms', []);
export const getRomSortedList = (state: AppState) => get(getRoms(state), 'list', {});
export const getRomsSearchCriteria = (state: AppState) => get(state, 'roms.searchCriteria', {});
